{
  "missed": "فائتة",
  "dashboard": {
    "title": "لوحة الخدمة",
    "intro": "ما يحتاج اليوم إلى فريق أو قرار أو فاتورة.",
    "strip": "أرقام الخدمة",
    "actions": {
      "schedule": "جدول الزيارات",
      "newJob": "أمر خدمة جديد"
    },
    "tiles": {
      "awaiting": "بانتظار زيارة",
      "awaitingDetail": "أوامر لم تُحجز لها زيارة",
      "today": "زيارات اليوم",
      "todayDetail_zero": "لا فرق في الميدان",
      "todayDetail_one": "فريق واحد في الميدان",
      "todayDetail_two": "فريقان في الميدان",
      "todayDetail_few": "{{n}} فرق في الميدان",
      "todayDetail_many": "{{n}} فريقًا في الميدان",
      "todayDetail_other": "{{n}} فريق في الميدان",
      "todayNone": "لا زيارات محجوزة اليوم",
      "followUps": "طلبات المتابعة",
      "followUpsDetail": "بانتظار الموافقة",
      "unfinished": "زِيرت وبقي عمل",
      "unfinishedDetail": "الزيارة التالية محجوزة أو لم تُحجز بعد",
      "ready": "جاهزة للفوترة",
      "readyDetail": "عمل مكتمل لم يُفوتر بعد",
      "collections": "تحصيلات للتحقق",
      "collectionsDetail": "مُبلّغ عنها",
      "planned": "وقائية للجدولة",
      "plannedDetail": "أوامر وقائية لم تُحجز كل زياراتها",
      "plannedNone": "كل الأوامر الوقائية محجوزة"
    },
    "overdue": {
      "none": "لا شيء متأخر.",
      "count_zero": "لا أوامر متأخرة",
      "count_one": "أمر خدمة واحد متأخر",
      "count_two": "أمرا خدمة متأخران",
      "count_few": "{{n}} أوامر متأخرة",
      "count_many": "{{n}} أمرًا متأخرًا",
      "count_other": "{{n}} أمر متأخر",
      "why": "فاتت زيارة أو مضى الموعد الموعود.",
      "open": "عرض الأوامر المتأخرة"
    },
    "today": {
      "title": "زيارات اليوم",
      "openSchedule": "فتح جدول الزيارات",
      "empty": "لا زيارات اليوم",
      "emptyBody": "تظهر هنا الزيارات المحجوزة لليوم، مجمّعة حسب الفريق.",
      "scheduleVisit": "حجز زيارة",
      "visits_zero": "لا زيارات",
      "visits_one": "زيارة واحدة",
      "visits_two": "زيارتان",
      "visits_few": "{{n}} زيارات",
      "visits_many": "{{n}} زيارة",
      "visits_other": "{{n}} زيارة",
      "lead": "قائد الزيارة: {{name}}",
      "noLead": "لم يُحدَّد قائد بعد"
    },
    "decisions": {
      "title": "بانتظارك",
      "followUps_one": "طلب متابعة واحد للموافقة",
      "followUps_other": "{{n}} طلب متابعة للموافقة",
      "collections_one": "دفعة واحدة للتحقق",
      "collections_other": "{{n}} دفعة للتحقق",
      "after": "بعد الزيارة {{n}}",
      "proposed": "يقترح {{date}}",
      "noDate": "لم يُقترح تاريخ",
      "approve": "موافقة",
      "approveLabel": "الموافقة على طلب {{number}}",
      "return": "إعادة",
      "returnLabel": "إعادة طلب {{number}}",
      "verify": "تحقق",
      "verifyLabel": "التحقق من دفعة {{number}}",
      "allFollowUps": "كل الطلبات",
      "allCollections": "كل التحصيلات",
      "collectedBy": "{{method}} · {{name}}",
      "followUps_zero": "لا طلبات متابعة للموافقة",
      "followUps_two": "طلبا متابعة للموافقة",
      "followUps_few": "{{n}} طلبات متابعة للموافقة",
      "followUps_many": "{{n}} طلب متابعة للموافقة",
      "collections_zero": "لا دفعات للتحقق",
      "collections_two": "دفعتان للتحقق",
      "collections_few": "{{n}} دفعات للتحقق",
      "collections_many": "{{n}} دفعة للتحقق"
    }
  },
  "board": {
    "title": "جدول الزيارات",
    "intro": "زيارات سبعة أيام من اليوم حسب الفريق. انقر يوم الفريق أو اسحب أمرًا إليه لحجز زيارة، واسحب زيارة لنقلها.",
    "introReadOnly": "زيارات سبعة أيام من اليوم حسب الفريق.",
    "awaitingList": "الأوامر بانتظار زيارة",
    "previousWeek": "الأسبوع السابق",
    "today": "اليوم",
    "holiday": "عطلة:",
    "dayOff": "يوم عطلة",
    "book": {
      "title": "حجز {{team}} يوم {{day}}",
      "short": "حجز",
      "filter": "تصفية الأوامر",
      "waiting": "الأوامر بانتظار زيارة",
      "noJobs": "لا أوامر بانتظار زيارة.",
      "noMatch": "لا أمر بانتظار زيارة يطابق البحث.",
      "newJob": "أمر جديد هنا…"
    },
    "nextWeek": "الأسبوع التالي",
    "weekRange": "{{from}} – {{to}}",
    "team": "الفريق",
    "allTeams": "كل الفرق",
    "gridLabel": "الزيارات حسب الفريق واليوم",
    "visitsCount_zero": "لا زيارات",
    "visitsCount_one": "زيارة واحدة",
    "visitsCount_two": "زيارتان",
    "visitsCount_few": "{{n}} زيارات",
    "visitsCount_many": "{{n}} زيارة",
    "visitsCount_other": "{{n}} زيارة",
    "dragHint": "لا يتغير شيء حتى تؤكده في نافذة الحجز. تُنقل فقط الزيارات التي لم تبدأ بعد.",
    "dayPicker": "اليوم",
    "noVisitsThatDay": "لا زيارات",
    "noTeams": "لا توجد فرق خدمة ميدانية بعد",
    "noTeamsBody": "تُحجز الزيارات لفريق يقوم بزيارات الخدمة. أنشئ فريقًا كهذا أو حدّد فريقًا قائمًا بأنه يقوم بزيارات الخدمة، بأعضائه وقادة زياراته.",
    "manageTeams": "إدارة الفرق",
    "unscheduled": {
      "title": "بانتظار زيارة",
      "hint": "الأكثر استعجالًا أولًا. اسحب الأمر إلى الجدول أو استخدم «حجز».",
      "hintReadOnly": "الأكثر استعجالًا أولًا.",
      "showAll": "عرض الـ{{n}} كلها في أوامر الخدمة",
      "empty": "لكل أمر مفتوح زيارة محجوزة.",
      "preferred": "يفضّل {{date}}",
      "scheduleJob": "حجز زيارة للأمر {{number}}",
      "schedule": "حجز",
      "noTeam": "دون فريق بعد",
      "requestsTitle": "طلبات بانتظار زيارة"
    },
    "followUps": {
      "title": "طلبات المتابعة",
      "hint": "وافق على الطلب لحجز زيارة المتابعة، أو أعده مع ملاحظة.",
      "hintReadOnly": "يوافق عليها مدير الخدمة أو يعيدها.",
      "openQueue": "فتح طلبات المتابعة",
      "empty": "لا طلبات متابعة بانتظار قرار.",
      "proposed": "مقترحة في {{date}}",
      "noDate": "لم يُقترح موعد",
      "requested": "{{name}} · {{when}}"
    },
    "introTouch": "زيارات سبعة أيام من اليوم حسب الفريق. اضغط «حجز» على أمر ينتظر زيارة لحجزها.",
    "planned": {
      "title": "وقائية للجدولة",
      "hint": "حسب تاريخ الاستحقاق، لكل عقد وموقع. اسحب الأمر إلى الجدول أو استخدم «حجز».",
      "hintReadOnly": "حسب تاريخ الاستحقاق، لكل عقد وموقع.",
      "showAll": "عرض الـ{{n}} كلها في أوامر الخدمة",
      "empty": "لكل أمر وقائي زياراته المحجوزة.",
      "due": "مستحق {{date}}",
      "overdue": "متأخر منذ {{date}}",
      "partScheduled": "جزء محجوز · التالي {{date}}",
      "scheduleJob": "حجز زيارة للأمر {{number}}",
      "scheduleNext": "حجز الجزء التالي",
      "assets_zero": "لا معدّات",
      "assets_one": "معدّة واحدة",
      "assets_two": "معدّتان",
      "assets_few": "{{n}} معدّات",
      "assets_many": "{{n}} معدّة",
      "assets_other": "{{n}} معدّة",
      "jobs_zero": "لا أوامر وقائية",
      "jobs_one": "أمر وقائي واحد",
      "jobs_two": "أمران وقائيان",
      "jobs_few": "{{n}} أوامر وقائية",
      "jobs_many": "{{n}} أمراً وقائياً",
      "jobs_other": "{{n}} أمر وقائي",
      "checksLeft_zero": "لا فحوص متبقية",
      "checksLeft_one": "فحص واحد متبقٍ",
      "checksLeft_two": "فحصان متبقيان",
      "checksLeft_few": "{{n}} فحوص متبقية",
      "checksLeft_many": "{{n}} فحصاً متبقياً",
      "checksLeft_other": "{{n}} فحص متبقٍ",
      "checked": "{{checked}} / {{total}} مفحوصة",
      "workDays_zero": "أقل من يوم عمل",
      "workDays_one": "نحو يوم عمل واحد",
      "workDays_two": "نحو يومَي عمل",
      "workDays_few": "نحو {{n}} أيام عمل",
      "workDays_many": "نحو {{n}} يوم عمل",
      "workDays_other": "نحو {{n}} يوم عمل",
      "workHours_zero": "أقل من ساعة عمل",
      "workHours_one": "نحو ساعة عمل واحدة",
      "workHours_two": "نحو ساعتَي عمل",
      "workHours_few": "نحو {{n}} ساعات عمل",
      "workHours_many": "نحو {{n}} ساعة عمل",
      "workHours_other": "نحو {{n}} ساعة عمل"
    }
  },
  "followUps": {
    "title": "طلبات المتابعة",
    "intro": "طلبات زيارة أخرى بعد زيارة تمت. وافق لحجز الزيارة، أو أعد الطلب مع ملاحظة.",
    "introReadOnly": "طلبات زيارة أخرى بعد زيارة تمت. يوافق عليها مدير الخدمة أو يعيدها.",
    "openSchedule": "فتح جدول الزيارات",
    "views": "طلبات المتابعة حسب الحالة",
    "empty": {
      "PENDING": "لا طلبات متابعة بانتظار الموافقة",
      "RETURNED": "لا طلبات معادة",
      "APPROVED": "لا طلبات موافق عليها بعد",
      "WITHDRAWN": "لا طلبات مسحوبة"
    },
    "emptyBody": {
      "PENDING": "إذا بقي عمل بعد زيارة، يظهر هنا طلب الفني لزيارة أخرى لتوافق عليه.",
      "RETURNED": "تبقى هنا الطلبات المعادة إلى الفني مع ملاحظة حتى يعيد تقديمها أو يسحبها.",
      "APPROVED": "الموافقة على الطلب تحجز زيارة المتابعة في الجدول.",
      "WITHDRAWN": "تُحفظ هنا الطلبات التي سحبها الفني."
    },
    "cardLabel": "طلب متابعة على {{number}}",
    "requestedBy": "طلبه {{name}} · {{when}}",
    "fields": {
      "fromVisit": "بعد"
    },
    "noDate": "لم يُقترح موعد",
    "decision": {
      "PENDING": "قرار سابق",
      "APPROVED": "تمت الموافقة",
      "RETURNED": "أُعيد",
      "WITHDRAWN": "سُحب"
    },
    "decidedBy": "{{name}} · {{when}}",
    "openVisit": "فتح زيارة المتابعة",
    "return": "إعادة",
    "approve": "موافقة",
    "returnLabel": "إعادة الطلب على {{number}}",
    "approveLabel": "الموافقة على الطلب على {{number}}",
    "needsApprover": "بانتظار قرار مدير الخدمة.",
    "partsTask": "إنشاء مهمة لقطع الغيار",
    "partsTaskLabel": "إنشاء مهمة لقطع غيار {{number}}",
    "partsTaskTitle": "قطع غيار {{number}}: {{what}}",
    "approveAsLabel": "الموافقة على طلب {{number}} كما اقتُرح",
    "change": "تعديل…",
    "changeLabel": "تعديل الزيارة قبل الموافقة على طلب {{number}}",
    "booked": "حُجزت زيارة المتابعة: {{team}}، {{date}}"
  },
  "collections": {
    "title": "التحصيلات",
    "intro": "مبالغ يبلّغ الفنيون عن تحصيلها. لا يتغير رصيد الفاتورة إلا عند التحقق من التحصيل، فبه يُسجَّل سند القبض.",
    "views": "التحصيلات حسب الحالة",
    "balance": "الرصيد",
    "empty": {
      "REPORTED": "لا شيء بانتظار التحقق",
      "VERIFIED": "لا تحصيلات متحقق منها بعد",
      "REJECTED": "لا تحصيلات مرفوضة"
    },
    "emptyBody": {
      "REPORTED": "عندما يبلّغ فني عن مبلغ حصّله على أمر خدمة، ينتظر هنا حتى تتحقق منه.",
      "VERIFIED": "تُدرج هنا التحصيلات المتحقق منها مع سند القبض الذي صار إليه كل منها.",
      "REJECTED": "تُحفظ هنا التحصيلات التي ترفضها مع السبب، ويُبلَّغ الفني."
    },
    "panel": {
      "title": "تحصيل على {{number}}",
      "loading": "تحصيل",
      "visit": "الزيارة",
      "openVisit": "فتح الزيارة",
      "number": "الرقم",
      "balanceNote": "لا يتغير رصيد الفاتورة إلا عند التحقق من هذا التحصيل."
    },
    "decided": {
      "verified": "تحقق منه {{name}} · {{when}}",
      "rejected": "رفضه {{name}} · {{when}}",
      "receipt": "سند القبض"
    },
    "decision": {
      "title": "التحقق من المبلغ",
      "how": "طريقة التحقق",
      "notAllowed": "لا يتحقق من هذا التحصيل أو يرفضه إلا من لديه صلاحية التحقق من المدفوعات.",
      "salesOff": "المبيعات غير مفعّلة لشركتك: التحقق يسجّل سند قبض، فلا يمكن التحقق من التحصيلات الآن. يمكنك رفض تحصيل لم يُستلم.",
      "create": "تسجيل سند قبض",
      "createBody": "سند قبض بالمبلغ يُخصَّص للفاتورة.",
      "link": "استخدام سند مسجّل",
      "linkBody": "المبلغ مسجّل أصلًا في سند قبض لهذا العميل (تحويل بنكي مثلًا).",
      "account": "أُودع في",
      "accountHint": "الحساب الافتراضي لطريقة الدفع، من إعدادات المدفوعات.",
      "accountsUnavailable": "لا يمكن عرض حسابات النقد والبنوك لك. اطلب من المسؤول صلاحية الاطلاع عليها.",
      "noAccounts": "لا يوجد حساب نقد أو بنك نشط بعد.",
      "chooseAccount": "اختر الحساب الذي أُودع فيه المبلغ.",
      "receiptDate": "تاريخ السند",
      "dateHint": "يوم التحصيل.",
      "chooseDate": "اختر تاريخ السند.",
      "receipt": "سند القبض",
      "receiptHint": "سندات القبض المرحّلة لهذا العميل، الأحدث أولًا.",
      "noReceipts": "لا يوجد لهذا العميل سند قبض مرحّل.",
      "chooseReceipt": "اختر سند القبض الذي يحمل هذا المبلغ.",
      "receiptOption": "{{number}} · {{date}} · {{amount}} (غير مخصّص {{credit}})",
      "reject": "رفض",
      "verifyCreate": "تحقق وسجّل سند القبض",
      "verifyLink": "تحقق بهذا السند",
      "receiptsUnavailable": "تعذّر تحميل سندات القبض لهذا العميل.",
      "chequeMissing": "أدخل رقم الشيك والبنك المسحوب عليه.",
      "noneFits": {
        "title": "لا يوجد هنا حساب يمكنه استلام هذه الدفعة",
        "cash": "النقد يدخل حسابًا نقديًا فقط، ودرج نقطة البيع لا يستلم إلا مبيعات نقطته.",
        "other": "دفعة البطاقة أو التحويل تدخل حسابًا بنكيًا أو حساب بطاقة أو محفظة، لا حسابًا نقديًا.",
        "add": "أضف حسابًا: افتح «{{field}}» واختر «{{action}}».",
        "ask": "اطلب ممن يدير الحسابات النقدية والبنكية إضافة حساب."
      }
    },
    "toast": {
      "verified": "تم التحقق من التحصيل",
      "verifiedWith": "تم التحقق من التحصيل · سند القبض {{number}}",
      "rejected": "تم رفض التحصيل"
    },
    "reject": {
      "title": "رفض هذا التحصيل؟",
      "body": "لن يُسجَّل سند قبض وتبقى الفاتورة كما هي. ويُبلَّغ الفني بالسبب.",
      "reason": "السبب",
      "required": "اذكر سبب الرفض.",
      "confirm": "رفض التحصيل"
    },
    "introReadOnly": "مبالغ أبلغتَ عن تحصيلها. يتحقق المحاسب من كل منها، وعندها يتغير رصيد الفاتورة.",
    "emptyBodyReadOnly": "تظهر هنا المبالغ التي تسجّلها في الزيارة حتى يُتحقق منها."
  }
}
